// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"5bab262f","80":"7ca8952e","533":"e9a20ab0","972":"b107fe25"}[chunkId] + ".css";
};